<script>
	// Stores 
	import { textSite, linkWhatsappCondominio, linkAV } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Vitrine		from '../components/Vitrine.svelte'

   	// Code	
	let titlePage = 'Gestão Condominial ';

	let vitrines = [
		{
			image: 'admCondo.png', 
			imageMobile: 'admCondoM.png', 
			title: 'Gestão Condominial',
			href: $linkAV,
			target: '_blank'
		},
	];

	let redItems = [
		{
			icon: 'fas fa-user',
			title: 'Atendimento Personalizado',
			text: '<ul><li>Assessor e assistente fixo para as demandas do condomínio.</li></ul>'
		},
		{
			icon: 'fas fa-money-bill',
			title: 'Departamento de Cobrança',
			text: '<ul><li>- Departamento próprio de cobrança.</li><li>Comunica mensalmente os condôminos inadimplentes. Cobrança judicial e extrajudicial.</li></ul>'
		},
		{
			icon: 'fas fa-balance-scale',
			title: 'Departamento Jurídico',
			text: '<ul><li>- Possuímos assessoria jurídica civil e trabalhista especializada em questões imobiliárias.</li><li>- Oferecemos gratuitamente consultas e orientações nas questões condominiais.</li><li>- Auxílio na elaboração e regularizar de convenções, registros e demandas judiciais.</li></ul>'
		},
		{
			icon: 'fas fa-briefcase',
			title: 'Síndico',
			text: '<ul><li>- Acesso a todas as informações financeiras de seu condomínio, situação da inadimplência, bem como uma série de orientações sobre questões relativas à administração condominial.</li></ul>'
		},

	];
	let blueItems = [
		{
			icon: 'fas fa-comment-dots',
			title: 'Departamento Pessoal',
			text: '<ul><li>- Seleção e recrutamento de funcionários.</li><li>- Contratação e demissão de funcionários.</li><li>- Pagamento de salário através de cartão–salário.</li><li>- Informações anuais DIRF e RAIS.</li><li>- Seguro de vida dos funcionários.</li></ul>'
		},
		{
			icon: 'fas fa-folder-open',
			title: 'Gestão de Arquivos',
			text: '<ul><li>- Arquivo durante o prazo legal, toda a documentação catalogada e arquivada separadamente por ano/mês, dando condições ao síndico de imediato acesso à documentação solicitada.</li></ul>'
		},
		{
			icon: 'fas fa-bullseye-arrow',
			title: 'Implantação de Condomínio',
			text: '<ul><li>- Assessoria para realização da Assembléia de Instalação.</li><li>- Registro CNPJ e ISSQN.</li><li>- Apoio jurídico e administrativo.</li><li>- Elaboração de convenção e Regimento Interno.</li></ul>'
		},
		{
			icon: 'fas fa-chart-line',
			title: 'Condôminos',
			text: '<ul><li>- Condôminos terão acesso a informações exclusivas de seu condomínio, tais como: Informes, Atas, Circulares, Regimento Interno, Convocações, Convenção do Condomínio, Reservas de Salão de Festas, Contato direto com síndico e assessor, Registro de ocorrências entre outras. Os condôminos podem emitir a segunda via do DOC de pagamento e acessar aos extratos mensais.</li></ul>'
		},
	];
	let yellowItems = [
		{
			icon: 'fas fa-wallet',
			title: 'Departamento de Orçamentos',
			text: '<ul><li>- Equipe apta a cotação de orçamentos para os mais diversos serviços e materiais.</li><li>- Controle das manutenções condominiais: seguro obrigatório, limpeza de caixa d’água, recarga de extintores, PPCI, LTIP...</li></ul>'
		},
		{
			icon: 'fas fa-users',
			title: 'Transição de Outra Administradora',
			text: '<ul><li>- Realizamos todo o processo de transferência de documentos e numerários da administradora anterior para a Freire.</li></ul>'
		},
		{
			icon: 'fas fa-credit-card',
			title: 'Cartão de Crédito',
			text: '<ul><li>- Oferecemos o Cartão de Crédito para Condomínios, os síndicos terão maior agilidade, comodidade e segurança nas compras do dia a dia do condomínio.</li><li>Consulte o custo mensal do cartão.</li></ul>'
		},
		{
			icon: 'fas fa-headset',
			title: 'Seguro Conteúdo Opcional Assistência 24h',
			text: '<ul><li>-Seguro de conteúdo contra incêndio, de qualquer causa, que cobrirá o conteúdo existente dentro do imóvel, até o limite contratado. Serviço de assistência 24h, para casos de emergência e sinistros.</li></ul>'
		},
	];
</script>

<PageHeader title={titlePage} buttons="" image="/assets/images/cabecalhos/interno_1.jpg" >
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<h2>SOLUÇÕES COMPLETAS PARA ADMINISTRAÇÃO DO SEU CONDOMÍNIO</h2>
			<img src="/assets/images/icons/imgGestao.png" alt="" aria-disabled="true" />
			<p class="mt-20">Além de auxiliarmos o síndico, nossa equipe se envolve com tudo que é de mais importante na vida condominial, investimos muito em tecnologia, experiência, transparência e qualidade nos serviços que oferecemos. Ao longo dos nossos 42 anos criamos processos customizados para as necessidades de cada condomínio, com isso um sistema de atendimento ágil e com proﬁssionais qualiﬁcados para a administração condominial.</p>
			<p>Aliado a isso, proporcionamos todo suporte e recursos necessários para garantir a eﬁciência administrativa e o gerenciamento completo das questões, ﬁnanceiras, ﬁscais e legais de um condomínio.</p>
		</div>
		<div class="text-center">
			<a class="btn btn-rounded btn-primary btn-lg bg-whatsapp" style="border: 2px solid #ffffff !important;" href="{$linkWhatsappCondominio}" target="_blank">
				<b>FALE CONOSCO</b>
			</a>
		</div>
	</div>
</PageHeader>

<div class="container clearfix text-justify">
	<div class="flex">
		<div class="round-all color-white background-accent text-subtitle text-bold pl-20 pr-20 pt-5 pb-5">Conheça nosso serviços:</div>
	</div>
	<div class="flex flex-center sm-flex-column gap-10 pt-20 pb-20 text-center">
		<div class="flex flex-column background-gray round-all flex-1 pa-20 gap-40">
			{#each redItems as item, i}
			<div class="item" style="min-height: 295px;">
				<div class="flex flex-center">
					<div class="background-red color-white circle r-75"><i class="{item.icon} fa-2x"></i></div>
				</div>
				<h5 class="text-bold pt-20">{item.title}</h5>
				<p>{@html item.text}</p>
			</div>
			{/each}
		</div>
		<div class="flex flex-column background-gray round-all flex-1 pa-20 gap-40">
			{#each blueItems as item, i}
			<div class="item">
				<div class="flex flex-center">
					<div class="background-blue color-white circle r-75"><i class="{item.icon} fa-2x"></i></div>
				</div>
				<h5 class="text-bold pt-20">{item.title}</h5>
				<p>{@html item.text}</p>
			</div>
			{/each}
		</div>
		<div class="flex flex-column background-gray round-all flex-1 pa-20 gap-40">
			{#each yellowItems as item, i}
			<div class="item" style="min-height: 298px;">
				<div class="flex flex-center">
					<div class="background-yellow color-white circle r-75"><i class="{item.icon} fa-2x"></i></div>
				</div>
				<h5 class="text-bold pt-20">{item.title}</h5>
				<p>{@html item.text}</p>
			</div>
			{/each}
		</div>
	</div>
	<div class="text-center pb-40 pt-20">
		<a class="btn btn-rounded btn-primary btn-lg bg-whatsapp" style="border: 2px solid #ffffff !important;" href="/solicite-proposta">
			<b>QUERO ORÇAMENTO</b>
		</a>
	</div>	
</div>
<div class="text-center">
	<a href={$linkAV} target="_blank">
		<img class="hidden-sm hidden-xs" src="/assets/images/vitrines/admCondo.png" alt="Freire Online" style="max-width: 100%"/>
		<img class="hidden-xl hidden-lg hidden-md" src="/assets/images/vitrines/admCondoM.png" alt="Freire Online" style="max-width: 100%"/>
	</a>
</div>
